import { AnswersState } from 'schemas/answerStateSchema';
import { getOfferItems } from 'utils/getOfferItems';
import { getPricePerQuantity } from './calculation';

export const getTotalInstallationPrice = (
  numPanels: number,
  answers: AnswersState
) => {
  if (answers.panelId) {
    const {
      panelItem,
      inverterItem,
      numInverters,
      batteryItem,
      chargerItem,
      installationItem,
    } = getOfferItems(answers, numPanels);

    const panelPrice =
      (panelItem && getPricePerQuantity(panelItem.prices, numPanels)) || 0;
    const inverterPrice =
      (inverterItem &&
        getPricePerQuantity(inverterItem.prices, numInverters)) ||
      0;
    const batteryPrice =
      (batteryItem && getPricePerQuantity(batteryItem.prices, 1)) || 0;
    const chargerPrice =
      (chargerItem && getPricePerQuantity(chargerItem.prices, 1)) || 0;
    const installationPrice =
      (installationItem &&
        getPricePerQuantity(installationItem.prices, numPanels)) ||
      0;

    console.log('---- price ----');
    console.log(`Panels price : ${panelPrice * numPanels}€`);
    console.log('Total inverters:', numInverters);
    console.log(`Inverter Price : ${inverterPrice}€`);
    console.log(`Battery Price : ${batteryPrice}€`);
    console.log(`Charger Price : ${chargerPrice}€`);
    console.log(`Installation Price per panel : ${installationPrice}€`);
    console.log(`Installation Price total : ${installationPrice * numPanels}€`);
    console.log('---------------');

    const totalPrice =
      panelPrice * numPanels +
      inverterPrice * numInverters +
      batteryPrice +
      chargerPrice +
      installationPrice * numPanels;

    return totalPrice;
  }

  return 0;
};
